import {Component, OnInit} from "@angular/core";
import {ParamConfigService} from "../../config-support/param-config.service";

@Component({
    selector: "woa-exit-page",
    templateUrl: "./exit-page.component.html",
})
export class ExitPageComponent implements OnInit {

    constructor(private paramConfig: ParamConfigService) {
    }

    async ngOnInit(): Promise<void> {
        if ((await this.paramConfig.getConfig()).nativeMode) {
            window.location.href = window.location.href + (window.location.href.indexOf("?") === -1 ? "?" : "&") + "exit";
        } else {
            window.location.reload();
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/start/exit-page/exit-page.component.ts